
import Home2 from "../../../assets/filled/Home2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Home2Icon({ className, dataTestid = "Home2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Home2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
